"use client";
import { motion } from "framer-motion";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { TrendingUp } from "lucide-react";

const data = [
  { name: "Week 1", views: 120 },
  { name: "Week 2", views: 350 },
  { name: "Week 3", views: 480 },
  { name: "Week 4", views: 720 },
];

export default function AnalyticsSection() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-indigo-50 via-white to-indigo-100 py-24">
      {/* Background gradient blobs */}
      <div className="absolute inset-0">
        <div className="absolute top-[-10%] left-[10%] w-96 h-96 bg-indigo-300 opacity-30 blur-3xl rounded-full" />
        <div className="absolute bottom-[-10%] right-[10%] w-96 h-96 bg-purple-300 opacity-30 blur-3xl rounded-full" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        {/* Title section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <div className="inline-flex items-center justify-center mb-4 px-4 py-2 rounded-full bg-white/60 backdrop-blur-md shadow-sm border border-indigo-100">
            <TrendingUp className="w-5 h-5 text-indigo-600 mr-2" />
            <span className="text-indigo-600 font-medium">Analytics Dashboard</span>
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Profile Growth <span className="text-indigo-600">Insights</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-12">
            Visualize your progress over time and measure your engagement performance in real-time.
          </p>
        </motion.div>

        {/* Chart card */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
          className="rounded-3xl shadow-2xl backdrop-blur-xl bg-white/70 border border-white/20 p-6 md:p-10"
        >
          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E0E7FF" />
              <XAxis dataKey="name" stroke="#94A3B8" />
              <YAxis stroke="#94A3B8" />
              <Tooltip
                contentStyle={{
                  backgroundColor: "rgba(255,255,255,0.9)",
                  borderRadius: "10px",
                  border: "1px solid #E0E7FF",
                }}
                labelStyle={{ color: "#6366F1", fontWeight: 600 }}
              />
              <Line
                type="monotone"
                dataKey="views"
                stroke="#6366F1"
                strokeWidth={4}
                dot={{ r: 6, fill: "#6366F1", stroke: "#fff", strokeWidth: 2 }}
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-12"
        >
          <button className="px-8 py-3 rounded-full text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 transition-all duration-300 shadow-lg hover:shadow-indigo-300/40 font-medium">
            View Detailed Analytics
          </button>
        </motion.div>
      </div>
    </section>
  );
}
